export default import.meta.ROLLDOWN_FILE_URL_8fqpkLb09KWHW2eUHkTnxg